const constants = {
  set: 'BOARD_EXPENSES_BY_CATEGORY_SET',
};

const set = (boardExpensesByCategory) => ({
  type: constants.set,
  payload: boardExpensesByCategory,
});

const boardExpensesByCategoryActions = {
  constants,
  set,
};

export default boardExpensesByCategoryActions;
